import { observer } from "mobx-react-lite";

import type { SettingsPage } from "../../stores/NavigationStore";
import { SplitView } from "../ui/SplitView";
import { AppearanceSettings } from "./AppearanceSettings";
import { GeneralSettings } from "./GeneralSettings";
import { SettingsList } from "./SettingsList";

/** The pages of the settings, next to the one that's open. */
export const SettingsScreen = observer(function SettingsScreen({ page }: { page?: SettingsPage }) {
    const detail = page === "appearance" ? <AppearanceSettings /> : page === "general" ? <GeneralSettings /> : undefined;

    return <SplitView listLabel="Settings" list={<SettingsList page={page} />} detail={detail} />;
});
